/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Ios_DeviceInputs */

const en_plan_ios_device = /** @type {(inputs: Plan_Ios_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS device`)
};

const es_plan_ios_device = /** @type {(inputs: Plan_Ios_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dispositivo iOS`)
};

/**
* | output |
* | --- |
* | "iOS device" |
*
* @param {Plan_Ios_DeviceInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_ios_device = /** @type {((inputs?: Plan_Ios_DeviceInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Ios_DeviceInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_ios_device(inputs)
	return en_plan_ios_device(inputs)
});